import React from "react";

const Navbar = () => {
  // Styles from your preferred layout
  const navStyle = {
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    backdropFilter: "blur(10px)",
    borderBottom: "2px solid #8B3232", 
    padding: "0.8rem 0"
  };

  const brandGroupStyle = {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    cursor: "default"
  };

  const logoStyle = {
    width: "60px", // Bigger logo as requested
    height: "60px",
    borderRadius: "50%",
    border: "1px solid #eee",
    transition: "transform 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
    objectFit: "cover"
  };

  const whatsappBtnStyle = {
    backgroundColor: "#8B3232", 
    color: "#ffffff",
    borderRadius: "0px", // Back to your original sharp square style
    transition: "all 0.3s ease",
    border: "none",
    fontSize: "0.9rem",
    letterSpacing: "0.5px"
  };

  return (
    <nav className="navbar navbar-expand-lg sticky-top shadow-sm" style={navStyle}>
      <div className="container">
        
        {/* Brand Group with Rolling Logo */}
        <div className="brand-group" style={brandGroupStyle}>
          <img
            src="/logo.png" 
            alt="Noor Fashion Logo"
            style={logoStyle}
            className="me-3 navbar-logo-roll"
          />
          <div className="d-flex flex-column leading-tight">
            <span className="m-0 p-0 text-uppercase" style={{ 
                fontSize: "1.6rem", 
                fontWeight: "700", 
                color: "#2D2D2D",
                letterSpacing: "1px" 
            }}>
                Noor
            </span>
            <small style={{ 
                fontSize: "0.75rem", 
                color: "#8B3232", 
                marginTop: "-5px", 
                fontWeight: "700",
                letterSpacing: "2px" 
            }}>
                FASHION
            </small>
          </div>
        </div>

        {/* Action Button */}
        <div className="ms-auto">
          <a
            href="https://wa.me/917878497980"
            target="_blank"
            rel="noopener noreferrer"
            className="btn px-4 py-2 d-flex align-items-center shadow-sm fw-bold"
            style={whatsappBtnStyle}
            onMouseOver={(e) => e.target.style.backgroundColor = "#6b2626"}
            onMouseOut={(e) => e.target.style.backgroundColor = "#8B3232"}
          >
            <i className="bi bi-whatsapp me-2"></i>
            WHATSAPP
          </a>
        </div>

      </div>

      <style>{`
        .brand-group:hover .navbar-logo-roll {
          transform: rotate(360deg);
        }
        
        @media (max-width: 576px) {
          .navbar-logo-roll { width: 50px !important; height: 50px !important; }
        }
      `}</style>
    </nav>
  );
};

export default Navbar;